import { ReactNode } from 'react'
import { useSelector } from 'react-redux'
import { getProfileState } from '@/profile/stores/store'
interface MenuProps {
  name: string
  icon: string
  link: string
  group: string
  service: string
  scopes?: String[]
  suffix?: string | ReactNode
  children?: MenuProps[]
  roles?: String[]
  code: string
}

const PORTAL_PREFIX = '/setting'
export const menu: MenuProps[] = [
  {
    icon: '',
    name: 'title',
    group: 'mission',
    service: 'stream',
    link: `${PORTAL_PREFIX}/mission`,
    code: 'MISSION_MANAGEMENT'
  },
]

export const getMenu = () => {
  const profile = useSelector(getProfileState)
  const codeAccess = new Set<string>()
  profile?.roles?.forEach((role) => role.resources?.forEach((resource) => codeAccess.add(resource.code || '')))

  const filterMenu = menu.filter((item) => codeAccess.has(item.code))
  return filterMenu
}
